import React, { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import initialImg from '../../../../images/icons/upload_new.svg';
import moment from 'moment';
import PopUp from '../../../../common/components/PopUp/PopUp';
import {
  getBusinessAddressProofITRUploadedUrl,
  UploadFileToS3,
  confirmBusinessAddressProofUploaded,
  getBusinessAddressProof
} from '../../../../common/constants/api';
import * as _ from 'lodash';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';

const ITR = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const [itr, setItr] = useState([]);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [tags, setTags] = useState([]);

  const getYear = () => `${moment().format('YYYY')}`;

  useEffect(() => {
    if (values.statementType) {
      handleOnChange(values.statementType);
    }
  }, [values.statementType]);

  const handleOnChange = value => {
    setFieldValue('statementType', value.toString());

    if (value == 'consolidated') {
      setItr([
        {
          index: 0,
          month: `Year ${getYear() - 3}-${getYear() - 1}`
        }
      ]);
    } else if (value == 'individual') {
      setItr([
        {
          index: 0,
          month: `Year ${getYear() - 1}`
        },
        {
          index: 1,
          month: `Year ${getYear() - 2}`
        },
        {
          index: 2,
          month: `Year ${getYear() - 3}`
        }
      ]);
    }
  };
  const handleGet = res => {
    let linksFromGet = _.get(res, 'links', []);
    let gettags = {};
    for (let link = 0; link < linksFromGet.length; link++) {
      gettags[_.get(linksFromGet[link], 'tag', 'NA').toString()] = {
        tag: _.get(linksFromGet[link], 'tag', ''),
        url: _.get(linksFromGet[link], 'url', '')
      };
    }
    if (linksFromGet.length <= 1) {
      setFieldValue('statementType', 'consolidated');
    } else {
      setFieldValue('statementType', 'individual');
    }
    setTags(gettags);
    if (linksFromGet.length != 0) {
      setFieldValue('preValues', true);
    } else {
      setFieldValue('preValues', false);
    }
  };

  useEffect(() => {
    setType('loading');
    setText('Uploading Please Wait...');
    setShow(true);

    getBusinessAddressProof(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      'itr'
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        handleGet(res);
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong'));
        setShow(true);
      });
  }, []);
  const handleConfirmationApiOnupload = (res, docName) => {
    if (!res.requestId) throw new Error(res);

    confirmBusinessAddressProofUploaded(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      res.requestId,
      'itr'
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setType('success');
        setText('Uploaded Successfully');
        setShow(true);
        setTimeout(() => setShow(false), 1000);
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong'));
        setShow(true);
      });
  };

  const handleUploadFile = (res, index, docName) => {
    if (!_.get(res, 'url', false)) {
      throw new Error(res);
    }

    UploadFileToS3(res.url, values.file[index][0])
      .then(uploaded => {
        if (uploaded.error) {
          throw new Error(uploaded);
        }
        handleConfirmationApiOnupload(res, docName);
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong'));
        setShow(true);
      });
  };
  const handleAndGetUrlForUpload = (index, docName) => {
    setType('loading');
    setText('Uploading Please Wait...');
    setShow(true);
    getBusinessAddressProofITRUploadedUrl(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      docName
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        handleUploadFile(res, index, docName);
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong'));
        setShow(true);
      });
  };

  const handleUpload = (index, docName) => {
    if (
      _.get(values, `file.${index}.0`, false) &&
      _.get(itr, `${index}.month`, false)
    ) {
      handleAndGetUrlForUpload(index, docName);
    }
  };

  useEffect(() => {
    handleUpload(0, _.get(itr, '0.month', false));
  }, [values.file[0]]);

  useEffect(() => {
    handleUpload(1, _.get(itr, '1.month', false));
  }, [values.file[1]]);

  useEffect(() => {
    handleUpload(2, _.get(itr, '2.month', false));
  }, [values.file[2]]);

  const handleEdit = month => {
    let all_tags = tags;
    if (all_tags.hasOwnProperty(month)) {
      let a = Object.keys(all_tags);
      let dictValues = {};
      for (let i = 0; i < a.length; i++) {
        if (a[i] != month) {
          dictValues[a[i]] = {
            tag: all_tags[a[i]].tag,
            url: all_tags[a[i]].url
          };
        }
      }
      setTags(dictValues);
    }
  };
  return (
    <div className="w-full mx-6 my-5">
      <div className="w-full">
        <p className="font-roboto font-medium text-base text-black-850 my-4 mx-2">
          ITR
        </p>
        <div className="w-full md:flex block my-4 px-3 md:px-0">
          <div className="mr-auto md:mr-2 md:ml-4 ml-2 my-3 md:my-0 flex md:flex-row flex-row-reverse">
            <RadioButton
              name="statementType"
              value={values.statementType == 'consolidated' ? true : false}
              checked={values.statementType == 'consolidated' ? true : false}
              onChange={() => handleOnChange('consolidated')}
              onBlur={handleBlur}
            />

            <p className="font-roboto font-normal text-sm text-black-500 ml-2 mr-auto">
              Consolidated Statement
            </p>
          </div>
          <div className="mr-auto ml-2 flex md:flex-row flex-row-reverse">
            <RadioButton
              name="statementType"
              value={values.statementType == 'individual' ? true : false}
              checked={values.statementType == 'individual' ? true : false}
              onChange={() => handleOnChange('individual')}
              onBlur={handleBlur}
            />
            <p className="font-roboto font-normal text-sm text-black-500 ml-2 mr-auto">
              Individual Statement
            </p>
          </div>
        </div>
      </div>
      <p className="font-roboto font-normal text-sm text-black-500 mx-4">
        Please upload Last 3 Years ITR
      </p>
      <div className="w-full flex flex-wrap ">
        {itr.map((each, index) => (
          <div className="mx-4 my-5">
            {tags.hasOwnProperty(each.month.toString()) ? (
              <div className="w-full">
                <div className="">{each.month}</div>
                <ShowGetImage
                  img={tags[each.month].url}
                  setEdit={() => handleEdit(each.month)}
                />
              </div>
            ) : (
              <GlobalUploadComp
                key={index}
                data={values}
                imgIndex={each.index} //0,1,2,3 depending upon the no of file sequence
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                setFieldError={setFieldError}
                initialImg={initialImg} // initial image
                subInst="Click here to upload"
                subtext="CHOOSE FILE"
                headerText={
                  <p className="text-center mt-1 text-black-500">
                    {each.month}
                  </p>
                }
              />
            )}
          </div>
        ))}
      </div>
      {itr.length != 0 ? (
        <button
          className="submitButton font-roboto text-white text-base w-48"
          disabled={Object.keys(errors).length != 0 ? true : false}
        >
          NEXT
        </button>
      ) : null}
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </div>
  );
};

export default ITR;
